/*
  La Fleury — el mega-menú se abre al pasar el ratón, como en las tiendas de
  moda. Se conserva el <details> de Dawn por debajo, así que el teclado y el
  clic siguen funcionando igual y no hace falta tocar su JavaScript.

  El retraso al cerrar existe porque entre el enlace y el panel hay un trozo de
  cabecera que NO es hijo del <li>: sin él, bajar el ratón hasta el panel
  dispararía mouseleave y el panel se cerraría en la cara.
*/
(function () {
  var RETRASO = 140;

  function preparar() {
    if (!window.matchMedia('(hover: hover)').matches) return;

    document.querySelectorAll('.header__inline-menu .lf-mega-item').forEach(function (item) {
      if (item.dataset.lfMega === 'listo') return;
      var det = item.querySelector('details');
      if (!det || !item.querySelector('.lf-mega')) return;
      item.dataset.lfMega = 'listo';

      var sum = det.querySelector('summary');
      var reloj;

      function abrir() {
        clearTimeout(reloj);
        if (!det.open) {
          det.open = true;
          if (sum) sum.setAttribute('aria-expanded', 'true');
        }
      }

      function cerrar() {
        clearTimeout(reloj);
        reloj = setTimeout(function () {
          det.open = false;
          if (sum) sum.setAttribute('aria-expanded', 'false');
        }, RETRASO);
      }

      item.addEventListener('mouseenter', abrir);
      item.addEventListener('mouseleave', cerrar);
      item.addEventListener('focusin', abrir);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preparar);
  } else {
    preparar();
  }
  // La cabecera fija se vuelve a pintar al hacer scroll en algunos temas.
  document.addEventListener('shopify:section:load', preparar);
})();
